import { Input } from "antd";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDebouncedEffect } from "../../hooks/useDebouncedEffect";
import styles from "./_styles.less";
import { useTranslation } from "react-i18next";

function Search(
  { search, onSearch, loading, searchOnEnterOrClick, formatter = "date" },
  ref
) {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState(search ?? "");
  const formatAsDate = (value) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 8);
    if (!cleaned) return "";
    if (cleaned.length <= 2) {
      return cleaned;
    } else if (cleaned.length <= 4) {
      return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
    } else {
      return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4)}`;
    }
  };

  const formatAsCpf = (value) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 11);
    return cleaned
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  };

const handleChange = (e) => {
  const rawValue = e.target.value;
  const numericOnly = rawValue.replace(/\D/g, "");
  const containsLetters = /[a-zA-Z]/.test(rawValue);

  if (formatter === "cpf") {
    setSearchText(numericOnly ? formatAsCpf(rawValue) : rawValue);
  } else if (formatter === "date") {
    if (containsLetters) {
      setSearchText(rawValue);
      return;
    }
    const cleaned = numericOnly.slice(0, 8);

    if (cleaned.length > 0) {
      const formatted = formatAsDate(cleaned);
      setSearchText(formatted.slice(0, 10));
    } else {
      setSearchText("");
    }
  } else {
    setSearchText(rawValue);
  }
};
  const triggerSearch = (value) => {
    if (typeof onSearch !== "function") return;
    let searchValue = value;
    if (formatter === "cpf") {
      const numericOnly = value.replace(/\D/g, "");
      searchValue = /^\d+$/.test(numericOnly) ? numericOnly : value;
    }
    onSearch(searchValue);
  };

  useDebouncedEffect(
    500,
    () => {
      if (!searchOnEnterOrClick) {
        triggerSearch(searchText);
      }
    },
    [searchText]
  );

  const handleSearchClick = () => {
    triggerSearch(searchText);
  };

  return (
    <Input.Search
      ref={ref}
      className={styles["search"]}
      value={searchText}
      onChange={handleChange}
      onSearch={handleSearchClick}
      loading={loading}
      autoFocus
    />
  );
}

Search.propTypes = {
  search: PropTypes.string,
  onSearch: PropTypes.func,
  loading: PropTypes.bool,
  searchOnEnterOrClick: PropTypes.bool,
  formatter: PropTypes.oneOf(["date", "cpf", "none"]),
};

export default React.forwardRef(Search);
